module.exports = __webpack_public_path__ + "img/employer_benefit_hero_mobile.1372885c.jpg";